module.exports = __webpack_public_path__ + "static/media/Mark Powell.df04773c.jpg";